module.exports = __webpack_public_path__ + "static/media/premisys_logo_dark.ab145f19.svg";